/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Err_Invariant_CompletedInputs */

const en_sch_err_invariant_completed = /** @type {(inputs: Sch_Err_Invariant_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A workflow needs at least one status in Completed, so work can be finished.`)
};

const de_sch_err_invariant_completed = /** @type {(inputs: Sch_Err_Invariant_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Workflow braucht mindestens einen Status in Abgeschlossen, damit Arbeit beendet werden kann.`)
};

/**
* | output |
* | --- |
* | "A workflow needs at least one status in Completed, so work can be finished." |
*
* @param {Sch_Err_Invariant_CompletedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_err_invariant_completed = /** @type {((inputs?: Sch_Err_Invariant_CompletedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Err_Invariant_CompletedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_err_invariant_completed(inputs)
	return en_sch_err_invariant_completed(inputs)
});